import React from 'react';

export const AditionalBenefits = () => (
  <div>
    <p className='membership-item__segment--free-msg'>Try Roland Cloud for 30-days FREE</p>
    <p>
      From beatmaker to novice musician to veteran performer, Roland Cloud’s
      diverse collection of instruments, sounds, and applications will inspire
      you to bring your ideas to life. Experience the rich history of Roland
      sound, through legendary analog synthesizers, iconic rhythm machines,
      famous sampled tones, and modern patch collections. Check out inimitable
      instruments like the JUNO-106, TR-808, and JUPITER-8, or embrace the
      future with our flagship plugin ZENOLOGY. Roland Cloud allows you make
      music on your terms. Create a driving beat, deliver a punchy bassline,
      or capture the perfect vocal take. For an audience of one or many, bring
      your sound to life with Roland Cloud. Join now!
    </p>
  </div>
);
